import { IPartnersCoverageGroup } from '../model/types'

/**
 * Markets available in the Coverage Report are the top level of the response:
 * every group the API returned data for, in the order the API sent them.
 */
export const getPartnersCoverageMarkets = (groups: IPartnersCoverageGroup[]) => {
  return groups.reduce<IPartnersCoverageGroup[]>((acc, group) => {
    if (acc.some((it) => it.market === group.market)) {
      return acc
    }

    return [...acc, group]
  }, [])
}
